import { useSelectedDealer } from "components/DealersAndLocationsDropdown/hooks";
import { useTypedQuery } from "hooks/useTypedQuery";
import { CommunicationSettingsQueryKeys } from "modules/CommunicationSettings/queryKeys";
import { ApiInstance } from "utils/Api";

export const usePdfTemplatesQuery = () => {
  const { selectedDealer } = useSelectedDealer();

  const { data, isLoading } = useTypedQuery({
    queryKey: CommunicationSettingsQueryKeys.pdfTemplates,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_id: selectedDealer?.id }, baseUrl)).data.report_templates
  });

  return { data, isLoading };
};
